<template>
  <div class="wrapper">
    <parallax
      class="section page-header header-filter"
      :style="headerStyle"
    ></parallax>
    <div class="main main-raised">
      <div class="section profile-content">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-50 mx-auto">
              <div class="profile">
                <div class="avatar">
                  <img
                    :src="img"
                    alt="Circle Image"
                    class="img-raised rounded-circle img-fluid"
                  />
                </div>
                <div class="name">
                  <h3 class="title">{{ sectionTitle }}</h3>
                </div>
              </div>
            </div>
          </div>
          <div class="description text-center">
            <p>{{ sectionDescription }}</p>
          </div>
          <div class="profile-tabs">
            <tabs
              :tab-name="['冰酒', '红酒', '甜酒 / 起泡酒', '烈酒']"
              :tab-icon="['format_list_bulleted', 'format_list_bulleted', 'format_list_bulleted', 'format_list_bulleted']"
              plain
              nav-pills-icons
              color-button="primary"
            >
              <!-- here you can add your content for tab-content -->
              <template slot="tab-pane-1">
                <div class="md-layout">
                  <ProductGallery :products="icewineList" />
                </div>
              </template>
              <template slot="tab-pane-2">
                <div class="md-layout">
                  <ProductGallery :products="wineList" />
                </div>
              </template>
              <template slot="tab-pane-3">
                <div class="md-layout">
                  <ProductGallery :products="sweetWineList" />
                </div>
              </template>
              <template slot="tab-pane-4">
                <div class="md-layout">
                  <ProductGallery :products="spiritList" />
                </div>
              </template>
            </tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import ProductGallery from "@/components/products/ProductGallery.vue";
  import { Tabs } from "@/components";
  import { webContent } from "@/language";
  export default {
    name: "Wine",
    components: {
      Tabs,
      ProductGallery
    },
    bodyClass: "profile-page",
    props: {
      header: {
        type: String,
        default: require("@/assets/img/bgs/Wine-Banner.jpg")
      },
      img: {
        type: String,
        default: require("@/assets/img/faces/winery.jpg")
      }
    },
    computed: {
      ...mapGetters(["products"]),
      sectionTitle() {
        return webContent.wineTitle.zh;
      },
      sectionDescription() {
        return webContent.wineDescription.zh;
      },
      headerStyle() {
        return {
          backgroundImage: `url(${this.header})`
        };
      },
      wineList() {
        return this.products.filter(item => item.product_category === 6);
      },
      sweetWineList() {
        return this.products.filter(item => item.product_category === 8);
      },
      icewineList() {
        return this.products.filter(item => item.product_category === 5);
      },
      spiritList() {
        return this.products.filter(item => item.product_category === 9);
      },
    },
    methods: {
      ...mapActions(["listProducts"])
    },
    mounted() {
      if (!this.products.length) {
        this.listProducts();
      }
    }
  };
</script>

<style lang="scss" scoped>
  .section {
    padding: 0;
  }

  .profile-tabs /deep/ {
    .md-card-tabs .md-list {
      justify-content: center;
    }
  }
  @media (max-width: 991px){
    .profile-tabs {
      margin-top: 0 !important;
      /deep/ .nav-tabs {
        display: flex;
        flex-wrap: wrap !important;

        .md-list-item {
          margin-left: 0;
        }

        .md-list-item-content.md-ripple {
          i {
            display: none;
          }
        }
      }
    }
  }
</style>
